import { get, post, put } from "../Service/ApiConfig";
import { ApiEndpoints, DoctorEndPoint, PatientEndPoint } from "../Service/Endpoints/ApiEndPoints";


export const getAllPatients = async ({ page, size, searchText, language }) => {
  const response = await get(
    PatientEndPoint.getAllPatients(page, size, searchText, language),
  );
  return response;
};

export const resetUserRetryCount = async (email) => {
  const response = await put(ApiEndpoints.resetUserRetryCount(email));
  return response;
}

export const searchDoctor = async (search) => {
  const response = await get(PatientEndPoint.searchPatients(search));
  return response;
};


